const state = {

    serverIp    : 'localhost',
    serverPort  : 3001,
    Loading     : false,
    Progress    : 0,
    Access_Tabs : []
    
  }
  
  const mutations = {
      SetProgress(state,payload){
        state.Progress = payload
      },
      SetLoading(state,payload){
        state.Loading = payload
      }
  }
  
  const actions = {
      
  }
  
  const getters = {

      GetProductionUrl(){
        
        if(process.env.NODE_ENV == 'development'){

          return 'http://localhost:3001'

        }else{

            return 'https://result-server.examin.online'
            
        }
      },
      GetLoading(state){
        return state.Loading 
      }
  }
  
  export default {
    state,
    mutations,
    actions,
    getters
  }
  